import React from "react";

import { Text, TextInput, StyleSheet, View } from "react-native";

export default function Input({ label, value, onValueChange, error }) {
  return (
    <View style={styles.inputContainer}>
      <Text style={styles.label}>{label}</Text>
      <TextInput
        value={value}
        style={styles.input}
        autoCapitalize="none"
        onChangeText={(val) => onValueChange(val)}
      ></TextInput>
      {error ? <Text style={styles.error}>{error}</Text> : null}
    </View>
  );
}
const styles = StyleSheet.create({
  label: {
    fontSize: 16,
    marginBottom: 6,
    marginTop: 5,
  },
  input: {
    width: "100%",
    padding: "10px",
    borderWidth: "1px",
    borderColor: "#ccc",
    borderRadius: "4px",
    marginBottom: 10,
    backgroundColor: "#ffffff"
  },
  inputContainer: {
    flex: 1
  },
  error: {
    marginTop: -10,
    fontSize: 13,
    fontStyle: "italic",
    color: "red",
  },
});
